import {RedmineMapping, RedmineMappingRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {dateToString} from "../../../../components/utils/dates";

export const RedmineMappingListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<RedmineMapping> = {
		title: "Listado de Mapeos ",
		onClick: "/app/admin/billing/mapping",
		headers: [
			{title: "Categoría"},
			{title: "Cliente"},
			{title: "Persona"},
			{title: "Valor original"},
			{title: "Valor destino"},
			{title: "Último uso"},
		],
		decorator: (bean: RedmineMapping) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					{bean.category}
				</TableCell>
				<TableCell>
					{bean.customer?.shortName}
				</TableCell>
				<TableCell>
					{bean.person?.surnamesAndName}
				</TableCell>
				<TableCell>
					{bean.originalValue}
				</TableCell>
				<TableCell>
					{bean.targetValue}
				</TableCell>
				<TableCell>
					{dateToString(bean.lastUse)}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			const ctrl = apiManager.factory(RedmineMappingRestControllerApiFactory);
			return ctrl.pageRedmineMapping(
				currentPage,
				size,
				undefined,
				term,
				showDismissed
			);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};